export default "__VITE_ASSET__CMXrySQI__"